let toastContainer = null;

function ensureContainer() {
  if (toastContainer) return toastContainer;
  const container = document.createElement('div');
  container.setAttribute('id', 'toast-notify-container');
  container.style.position = 'fixed';
  container.style.top = '12px';
  container.style.left = '50%';
  container.style.transform = 'translateX(-50%)';
  container.style.zIndex = '2000';
  container.style.display = 'flex';
  container.style.flexDirection = 'column';
  container.style.gap = '8px';
  document.body.appendChild(container);
  toastContainer = container;
  return container;
}

export function toastNotify(message, { type = 'success', duration = 3000 } = {}) {
  const container = ensureContainer();

  const toast = document.createElement('div');
  toast.style.minWidth = '280px';
  toast.style.maxWidth = '640px';
  toast.style.margin = '0 auto';
  toast.style.padding = '10px 14px';
  toast.style.borderRadius = '10px';
  toast.style.boxShadow = '0 6px 20px rgba(0,0,0,0.08)';
  toast.style.border = '1px solid';
  toast.style.fontSize = '14px';
  toast.style.fontWeight = '600';
  toast.style.backdropFilter = 'saturate(180%) blur(8px)';
  toast.style.transition = 'opacity 180ms ease, transform 180ms ease';
  toast.style.opacity = '0';
  toast.style.transform = 'translateY(-8px)';

  if (type === 'error') {
    toast.style.background = '#f8d7da';
    toast.style.color = '#842029';
    toast.style.borderColor = '#f5c2c7';
  } else if (type === 'warning') {
    toast.style.background = '#fff3cd';
    toast.style.color = '#664d03';
    toast.style.borderColor = '#ffecb5';
  } else {
    toast.style.background = '#d1e7dd';
    toast.style.color = '#0f5132';
    toast.style.borderColor = '#badbcc';
  }

  toast.textContent = message;
  container.appendChild(toast);

  requestAnimationFrame(() => {
    toast.style.opacity = '1';
    toast.style.transform = 'translateY(0)';
  });

  const remove = () => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(-8px)';
    setTimeout(() => {
      if (toast.parentNode) toast.parentNode.removeChild(toast);
      if (toastContainer && toastContainer.children.length === 0) {
        toastContainer.parentNode?.removeChild(toastContainer);
        toastContainer = null;
      }
    }, 200);
  };

  if (duration > 0) {
    setTimeout(remove, duration);
  }

  return { close: remove };
}


